import { Component, OnInit, ViewChild } from "@angular/core";
import { StaffDigitalIdEmailLogComponent } from "./staff-digital-id-email-log/staff-digital-id-email-log.component";

@Component({
	selector: "app-staff-digital-id-registration",
	templateUrl: "./staff-digital-id-registration.component.html",
	styleUrls: ["./staff-digital-id-registration.component.css"],
})
export class StaffDigitalIdRegistrationComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	SelectMode: string = "Manual"; //Manual | Batch
	EmailLogExpand: boolean = false;

	@ViewChild(StaffDigitalIdEmailLogComponent)
	emailRef: StaffDigitalIdEmailLogComponent;

	///////////////////////////////////////////////////////////////////////////

	onEmailRefresh() {
		this.EmailLogExpand = true;
		this.emailRef.onRefresh();
	}
}
